/**
 * Mindstate Home Page Enhancements
 * - Inject "ZOBACZ WSZYSTKIE" link in product list section headers
 * - Make hero clickable
 */
(function() {
  'use strict';

  function buildProductCard(p) {
    var link = document.createElement('a');
    link.href = '/products/' + p.handle;
    link.className = 'ms-pp__product';

    var src1 = p.images && p.images[0] ? p.images[0].src : '';
    var src2 = p.images && p.images[1] ? p.images[1].src : src1;
    var variant = p.variants && p.variants[0] ? p.variants[0] : {};
    var price = parseFloat(variant.price || 0);
    var compareAt = parseFloat(variant.compare_at_price || 0);

    var imgWrap = document.createElement('div');
    imgWrap.className = 'ms-pp__product-img';

    var img1 = document.createElement('img');
    img1.className = 'ms-pp__img-primary';
    img1.src = src1;
    img1.alt = p.title;
    img1.loading = 'lazy';
    img1.width = 600;
    img1.height = 800;

    var img2 = document.createElement('img');
    img2.className = 'ms-pp__img-secondary';
    img2.src = src2;
    img2.alt = p.title;
    img2.loading = 'lazy';
    img2.width = 600;
    img2.height = 800;

    imgWrap.appendChild(img1);
    imgWrap.appendChild(img2);

    var info = document.createElement('div');
    info.className = 'ms-pp__product-info';

    var titleEl = document.createElement('div');
    titleEl.className = 'ms-pp__product-title';
    titleEl.textContent = p.title;

    var priceEl = document.createElement('div');
    priceEl.className = 'ms-pp__product-price';
    var priceFmt = price.toFixed(2).replace('.', ',') + ' zł';
    var compareFmt = compareAt > price ? compareAt.toFixed(2).replace('.', ',') + ' zł' : '';
    priceEl.innerHTML = priceFmt + (compareFmt ? ' <span class="ms-pp__compare">' + compareFmt + '</span>' : '');

    info.appendChild(titleEl);
    info.appendChild(priceEl);
    link.appendChild(imgWrap);
    link.appendChild(info);
    return link;
  }

  function initPpSection(section) {
    if (section.dataset.msInit) return;
    section.dataset.msInit = '1';

    var ppGrid = section.querySelector('[data-ms-pp-grid]');
    var bottomLink = section.querySelector('[data-ms-pp-bottom-link]');

    function renderHandle(handle) {
      if (!ppGrid) return;
      ppGrid.innerHTML = '<div class="ms-pp__loading">Ładowanie...</div>';
      if (bottomLink) bottomLink.href = '/collections/' + handle;

      fetch('/collections/' + handle + '/products.json?limit=4')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.products || [];
          if (products.length === 0) {
            ppGrid.innerHTML = '<div class="ms-pp__loading">Brak produktów w tej kategorii</div>';
            return;
          }
          ppGrid.innerHTML = '';
          products.forEach(function(p) {
            ppGrid.appendChild(buildProductCard(p));
          });
        })
        .catch(function(err) {
          ppGrid.innerHTML = '<div class="ms-pp__loading">Nie udało się załadować produktów</div>';
          console.error('ms-pp error:', err);
        });
    }

    section.querySelectorAll('.ms-pp__tab').forEach(function(btn) {
      btn.addEventListener('click', function() {
        section.querySelectorAll('.ms-pp__tab').forEach(function(b) {
          b.classList.remove('ms-pp__tab--active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('ms-pp__tab--active');
        btn.setAttribute('aria-selected', 'true');
        renderHandle(btn.dataset.handle);
      });
    });

    var defaultHandle = section.dataset.defaultHandle || 'nowosci';
    renderHandle(defaultHandle);
  }

  function enhance() {
    // Inject ZOBACZ WSZYSTKIE link
    document.querySelectorAll('h6').forEach(function(h) {
      if (!/NAJCZĘŚCIEJ|WYBIERANE|NAJNOWSZE|BACK IN STOCK|ZNÓW DOSTĘPNE/i.test(h.innerText)) return;
      if (h.dataset.msEnhanced) return;
      h.dataset.msEnhanced = '1';

      var parent = h.parentElement;
      var grandparent = parent.parentElement;

      grandparent.style.justifyContent = 'space-between';
      grandparent.style.alignItems = 'center';
      grandparent.style.width = '100%';

      if (!parent.nextElementSibling || !parent.nextElementSibling.classList.contains('ms-see-all')) {
        var link = document.createElement('a');
        link.className = 'ms-see-all';
        link.href = '/collections/all';
        link.textContent = 'ZOBACZ WSZYSTKIE';
        parent.parentNode.insertBefore(link, parent.nextSibling);
      }
    });

    // Make hero clickable
    document.querySelectorAll('.hero-wrapper .hero').forEach(function(hero) {
      if (hero.dataset.msLinked) return;
      hero.dataset.msLinked = '1';
      hero.style.cursor = 'pointer';
      hero.addEventListener('click', function() {
        window.location.href = '/collections/all';
      });
    });

    // Init all .ms-pp tab sections
    document.querySelectorAll('.ms-pp').forEach(initPpSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  document.addEventListener('shopify:section:load', enhance);
})();
